import { environment } from '../../../../../../environments/environment';
import { Inject, Injectable } from '@angular/core';
import { UserViewService } from '../../../../../shared/sub-modules/user-views/services/user-view.service';
import { HttpClient } from '@angular/common/http';

/** Servicio para acceder a las líneas de la API */
@Injectable()
export class LinesService extends UserViewService {
  urlBase = environment.urlLogistics;
  /** Inicializa el recurso logistica/lineas */
  constructor(
    http: HttpClient,
    linesEndpoint: string
  ) {
    super(linesEndpoint, http);
  }
}
